import { setupWdyr } from './wydr';
import { setAppUrlRoot } from './app/core/utils';

const run = async () => {
  const mainfestPath = document
    .querySelector('#manifest-link-el')
    ?.getAttribute('href');
  if (!mainfestPath) {
    throw new Error('Mainfest link is not detected in the page.');
  }
  await setupWdyr();

  const launchScript = document.createElement('script');
  launchScript.async = true;
  launchScript.src = localStorage.getItem('launchScriptSource') || '';
  document.body.appendChild(launchScript);

  const appBase = mainfestPath.replace('manifest.json', '');
  setAppUrlRoot(appBase);
  const { renderApp } = await import('./render-app');
  await renderApp();
  console.log('App Rendered');
};
(async function () {
  try {
    await run();
  } catch (err) {
    console.error(err);
  }
})();
